// extracted by mini-css-extract-plugin
export default {"topMenu":"f43d491f6f06991ee01b","link":"b002dab6b1250348eac2"};